module.exports = __webpack_public_path__ + "img/btn_menu-open.49a819eb.png";